module.exports = __webpack_public_path__ + "img/map_Z5.2.A.01.7a2b3f95.svg";